import React from 'react';
import ColumnMapper, { OptionInfo, TargetField } from '#/common/components/ColumnMapper';
import { StyledNuvoBox } from '#/common/styles/template';
import { NuvoLabel } from '@nuvolo/nuux-core/components/NuvoLabel';
import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';

// Define the non-mandatory fields
const additionalFields = [
  { key: 'assigned_to_email', label: 'Assigned To (Email)' },
  { key: 'type', label: 'Type' },
  { key: 'priority', label: 'Priority' },
  { key: 'due_date', label: 'Due Date' },
] as TargetField[];

export interface MapWorkOrderAdditionalFieldsStepProps {
  csvColumns: OptionInfo[];
  mapping: Record<string, string>;
  setMapping: React.Dispatch<React.SetStateAction<Record<string, string>>>;
}

const MapWorkOrderAdditionalFieldsStep: React.FC<MapWorkOrderAdditionalFieldsStepProps> = ({
  csvColumns,
  mapping,
  setMapping,
}) => {
  const { isDesktop } = useViewport();

  return (
    <StyledNuvoBox isDesktop={isDesktop}>
      <div className="box-caption">
        <NuvoLabel>Match Additional Columns</NuvoLabel>
      </div>

      <ColumnMapper
        sourceOptions={csvColumns}
        targetFields={additionalFields}
        mapping={mapping}
        setMapping={setMapping}
        sourceLabel="Your File Columns"
        targetLabel="TMM Columns"
      />
    </StyledNuvoBox>
  );
};

export default React.memo(MapWorkOrderAdditionalFieldsStep);
